module.exports = __webpack_public_path__ + "img/avatar3.abb6a2fd.png";